/**
 * OfficeRuntime.storage keys and Excel custom property keys.
 * These are shared across commands.ts, App.tsx, useAppController.ts,
 * filterStateManager.ts, marketWatchFilterState.ts, and route components.
 */

/** Keys for OfficeRuntime.storage (cross-context communication) */
export const STORAGE_KEYS = {
  TOKEN: "token",
  DASHBOARD_GENERATING: "dashboard_generating",
  DASHBOARD_GENERATING_NAME: "dashboard_generating_name",
  DASH_FILTER: "dash_filter",
  FILTER_UI_SOURCE: "filter_ui_source",
  NAVIGATE_TO_SAVE_TEMPLATES: "navigate_to_save_templates",
  REFRESH_ADVERTISING_FILTERS: "refresh_advertising_filters",
  MW_NAV_FILTERS: "mw_nav_filters",
  DASHBOARD_FILTER_STATES: "dashboard_filter_states",
} as const;

/** Values stored in STORAGE_KEYS.FILTER_UI_SOURCE */
export const FILTER_UI_SOURCES = {
  DASHBOARD: "dashboard",
  DATA: "data",
} as const;

/** Excel custom property keys (per-sheet metadata) */
export const CUSTOM_PROPERTIES = {
  MW_FILTERS: "mw_filters",
  MW_DATA_FINGERPRINT: "mw_data_fingerprint",
  ADVERTISING_FILTERS: "advertising_filters",
} as const;
